import { Footer } from "./style";
import { AiFillInstagram, AiFillYoutube, AiOutlineGlobal } from "react-icons/ai";
import { BsFacebook, BsLinkedin } from "react-icons/bs";
import { FiArrowUpRight } from "react-icons/fi";

function FooterComponent(params) {
  return (
    <Footer>
      <div id="father-div">
        <p>© 2025 - Flávio Moura</p>
        <div>
          <a target="blank" href="https://www.instagram.com/flavioflmoura"><AiFillInstagram /></a>
          <a target="blank" href="https://www.facebook.com/proflaviomoura"><BsFacebook /></a>
          <a target="blank" href="https://www.youtube.com/channel/UCCLEEkp4XHX03xTukr31QVw"><AiFillYoutube /></a>
          <a target="blank" href="https://www.linkedin.com/in/flavioflmoura"><BsLinkedin /></a>
          <a target="blank" href="https://www.flavio-moura.com/"><AiOutlineGlobal /></a>
        </div>
        <button><a href="#theheader">Voltar ao topo <FiArrowUpRight/></a></button>
      </div>
    </Footer>
  );
}

export default FooterComponent;
